// @flow
/* eslint-disable no-nested-ternary */

import { createValidator, required } from 'gandi.react-form';
import type { TranslatorProps } from '@gandi/translate/dist/types';

import type { Props as AbuseFormProps } from './AbuseForm';

type Props = {|
  ...AbuseFormProps,
  translator: TranslatorProps,
|};

type DataProps = {|
  requiredIfCategoryTopic: boolean,
|};

const requiredIfCategoryTopic =
  (category: string, topic: string) =>
  (value: boolean, data: DataProps, props: Props) => {
    const { routeParams } = props;
    if (routeParams.category === category) {
      if (routeParams.topic === topic) {
        return required(value, data, props);
      }
      return undefined;
    }
    return undefined;
  };

const emailFormat = /.+@[^@]+\.[^@]{2,}/;

const email = (value: string, data: DataProps, props: Props) =>
  value && !emailFormat.test(value)
    ? props.translator.__('Must be a valid E-mail address')
    : undefined;

const abuseFormValidation: any = createValidator({
  firstname: [required],
  lastname: [required],
  orgname: [required],
  reply_to: [required, email],
  resource_name: [
    requiredIfCategoryTopic('domain', 'whois'),
    requiredIfCategoryTopic('domain', 'spam'),
    requiredIfCategoryTopic('domain', 'cybersquatting'),
    requiredIfCategoryTopic('domain', 'phishing'),
    requiredIfCategoryTopic('domain', 'other'),
    requiredIfCategoryTopic('hosting', 'spam'),
  ],
  message: [
    requiredIfCategoryTopic('domain', 'cybersquatting'),
    requiredIfCategoryTopic('domain', 'other'),
    requiredIfCategoryTopic('hosting', 'illegal'),
    requiredIfCategoryTopic('hosting', 'breaching'),
    requiredIfCategoryTopic('hosting', 'pirated'),
    requiredIfCategoryTopic('hosting', 'other'),
  ],
  params: {
    whois_contact: [required],
    involved_fields: [required],
    mail_headers: [
      requiredIfCategoryTopic('domain', 'spam'),
      requiredIfCategoryTopic('hosting', 'spam'),
    ],
    url: [
      requiredIfCategoryTopic('domain', 'phishing'),
      requiredIfCategoryTopic('hosting', 'illegal'),
      requiredIfCategoryTopic('hosting', 'breaching'),
      requiredIfCategoryTopic('hosting', 'other'),
    ],
    phone_number: [requiredIfCategoryTopic('hosting', 'breaching')],
    type: [requiredIfCategoryTopic('hosting', 'breaching')],
    legal_form: [requiredIfCategoryTopic('hosting', 'breaching')],
    denomination: [requiredIfCategoryTopic('hosting', 'breaching')],
    headquarter: [requiredIfCategoryTopic('hosting', 'breaching')],
    name: [requiredIfCategoryTopic('hosting', 'breaching')],
    firstnames: [requiredIfCategoryTopic('hosting', 'breaching')],
    profession: [requiredIfCategoryTopic('hosting', 'breaching')],
    address: [requiredIfCategoryTopic('hosting', 'breaching')],
    nationality: [requiredIfCategoryTopic('hosting', 'breaching')],
    description: [requiredIfCategoryTopic('hosting', 'breaching')],
    reasons: [requiredIfCategoryTopic('hosting', 'breaching')],
    copy: [requiredIfCategoryTopic('hosting', 'breaching')],
    source_ip: [requiredIfCategoryTopic('hosting', 'pirated')],
    target_ip: [requiredIfCategoryTopic('hosting', 'pirated')],
    hours: [requiredIfCategoryTopic('hosting', 'pirated')],
    logs: [requiredIfCategoryTopic('hosting', 'pirated')],
    location: [requiredIfCategoryTopic('hosting', 'malware')],
  },
});

export default abuseFormValidation;
